<script setup lang="ts">
import { storeToRefs } from 'pinia'

const portfolioStore = usePortfolioStore()
const { activePortfolio } = storeToRefs(portfolioStore)
</script>

<template>
  <section v-if="activePortfolio">
    <NetWorth :value="activePortfolio.total" />

    <template v-if="false">
      <TitleComponent title="Asset distribution" />
      <PortfolioAssetComposition :total-value="activePortfolio!.total.value" :totals="activePortfolio!.grouped_totals" />
    </template>

    <AssetSearchHeader />

    <MarketIndicesList />

    <section class="mt-8">
      <TitleComponent title="Watch list" />
      <AssetsWatchingList />
    </section>

    <template v-if="false">
      <TitleComponent title="Wishlist" />
      <AssetsList :assets="activePortfolio!.assets" />
    </template>
  </section>
</template>
